import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import { Pricing } from 'routes/Menu/domains/pricing'
import { getPreviewOrderId } from 'selectors/basket'

export const trackingOrderPlaceAttempt: CheckoutActionCreator =
  ({ pricing }: { pricing: Pricing }) =>
  (dispatch, getState) => {
    const state = getState()

    dispatch({
      type: actionTypes.CHECKOUT_ORDER_PLACE_ATTEMPT,
      trackingData: {
        actionType: trackingKeys.placeOrderAttempt,
        order_id: getPreviewOrderId(state),
        order_total: pricing?.grossTotal,
        promo_code: pricing?.promoCode,
        payment_provider: 'checkout',
      },
    })
  }
